<template>
  <div>
    <NavBar
      :codart="$route.params.articulo"
      :catart="
        InfoArticulo({
          articulo: Articulo,
          label: `Categoria`,
          codigo: $route.params.articulo,
          isString: true,
        })
      "
      :scat="
        InfoArticulo({
          articulo: Articulo,
          label: `SubCategoria`,
          codigo: $route.params.articulo,
        })
      "
      :scatart="
        InfoArticulo({
          articulo: Articulo,
          label: `NombreSubCat`,
          codigo: $route.params.articulo,
        })
      "
      :cat="
        InfoArticulo({
          articulo: Articulo,
          label: `NombreCat`,
          codigo: $route.params.articulo,
        })
      "
      :web="
        InfoArticulo({
          articulo: Articulo,
          label: `Web`,
          codigo: $route.params.articulo,
        })
      "
    />
    <v-container
      grid-list-md
      :class="['mb-12', 'mt-n3']"
      style="max-width: 1140px"
      v-scroll="onScroll"
    >
      <Loading v-if="Articulo.length === 0" />
      <v-row v-else no-gutters>
        <v-col cols="12" class="white d-flex d-md-none">
          <NombreArticulo />
        </v-col>
        <v-col cols="12" md="6">
          <Galeria :codart="$route.params.articulo" />
        </v-col>
        <v-col cols="12" md="6">
          <v-row no-gutters>
            <v-col cols="12" class="white d-none d-md-flex">
              <NombreArticulo />
            </v-col>
            <v-col cols="12" v-if="dataUser.IndAutenticado && Articulo[0].DisponTxt === 'Disponible:'">
              <StockArticuloU v-if="dataUser.TipoUsuario == 'U'" />
              <StockArticulo v-else />
            </v-col>
            <v-col
              cols="12"
              v-if="Articulo[0].Formato !== ''"
            >
              <CaracteristicasArticulo />
            </v-col>
            <v-col
              cols="12"
              v-if="Articulo[0].UniVenta === 'M2'"
            >
              <VolumenArticulo />
            </v-col>
            <v-col
              class="mt-3 mb-n3"
              cols="12"
              v-if="dataUser.IndAutenticado && dataUser.VerPrecios[tipoMoneda]"
            >
              <PrecioNormal />
            </v-col>
            <v-col
              class="mt-3"
              cols="12"
              v-if="
              !Articulo[0].Proximo &&
                dataUser.IndAutenticado &&
                dataUser.VerPrecios[tipoMoneda] &&
                Articulo[0].Promocion
              "
            >
              <PrecioPromocion />
            </v-col>

            <v-col
              v-if="Articulo[0].Precio[tipoMoneda]!==0 && Articulo[0].Stock !== 0"
              cols="12"
            >
              <btnAdd
                class="mt-4 ml-2"
                :selcliente="Cliente.showOpc"
                :userAuth="dataUser.IndAutenticado"
                :codArt="$route.params.articulo"
                :promo="promoArt($route.params.articulo)"
                color="transparent"
                @promoArticulo="newCant"
                :tipoConsulta="2"
                :item="Articulo[0]"
                :ver="true"
                :textbtn="`agregar`"
              />
            </v-col>
            <v-col
              cols="12"
              v-if="!Articulo[0].Proximo && dataUser.IndAutenticado && Articulo[0].Promocion"
            >
              <TablaPromocion />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12">
          <EspecificacionesList />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { InfoExistencia } from "@/components/InfoExistencia";
  import { Loading } from "@/components/LoadingDomo";
  import NavBar from "@/components/Navegacion";
  import btnAdd from "@/components/botonadd";
  import {
    NombreArticulo,
    StockArticulo,
    StockArticuloU,
    VolumenArticulo,
    CaracteristicasArticulo,
    TablaPromocion,
    PrecioNormal,
    PrecioPromocion,
    Galeria,
    EspecificacionesList,
  } from "@/components/ArticuloDetalle";
  import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

  export default {
    computed: {
      ...mapGetters(["isManual"]),
      ...mapState([
        "Articulo",
        "dataUser",
        "Cliente",
        "tipoMoneda"
      ]),
      promoArt: function () {
        return function (id) {
          var nb = false;
          if (this.Articulo) {
            nb = this.Articulo.filter((x) => x.Codigo === id)
              .map((x) => x.Promocion)
              .toString();
            return this.dataUser.IndAutenticado === true
              ? this.parseBool(nb)
              : "";
          }
        };
      },
      InfoArticulo: function () {
        return function ({ articulo, label, codigo, isString = false }) {
          if (articulo) {
            const infoArt = articulo
              .filter((x) => x.Codigo === codigo)
              .map((x) => x[label]);
            return isString ? infoArt[0] + "" : infoArt[0];
          }
        };
      },
    },
    components: {
      Loading,
      NavBar,
      NombreArticulo,
      StockArticulo,
      StockArticuloU,
      VolumenArticulo,
      CaracteristicasArticulo,
      TablaPromocion,
      btnAdd,
      PrecioNormal,
      PrecioPromocion,
      InfoExistencia,
      Galeria,
      EspecificacionesList,
    
    },
    data() {
      return {
        promoDetalleArt: [],
        cantMin: 1,
        codXart: false,
        codArtPromo: null,
      };
    },
    methods: {
      ...mapActions(["cargarDatosPromo", "cargarFeature", "cargarDatosArt"]),
      ...mapMutations(["CLR_ERROR_AXIOS", "CLR_DATOS_ART"]),
      GetManual() {
        if (this.isManual) return this.isManual;
      },
      parseBool(str) {
        if (str.length == null) {
          return str == 1 ? true : false;
        } else {
          return str == "true" ? true : false;
        }
      },
      newCant(datos, cant, status, cod) {
        this.promoDetalleArt = datos;
        this.cantMin = cant;
        this.codXart = status;
        this.codArtPromo = cod;
      },
      onScroll(e) {
        if (typeof window === "undefined") return;
        const top = window.pageYOffset || e.target.scrollTop || 0;
        this.fab = top > 80;
      },
    },
    created() {
      const routeArt = this.$route.params.articulo
      this.GetManual();
      window.scrollTo(0, 0);
      this.CLR_ERROR_AXIOS();
      this.cargarDatosArt({ codart: routeArt });
      this.cargarDatosPromo({ codart: routeArt });
      this.cargarFeature({
        articulo: routeArt,
        cia: 15,
        opc: 8,
        status: 1,
      });
      this.CLR_DATOS_ART();
    },
  };
</script>

<style></style>
